import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.adminRegistryPage.setFetching(isFetching)

const fetchOrders = ({ fromInt, toInt, schoolId, classId }) => {
  const { marketplace: { adminRegistryPage: { schools } } } = getState()

  reducers.marketplace.adminRegistryPage.resetOrders()

  const schoolsList = schoolId ? [ schoolId ] : schools.map(({ id }) => id )

  return Promise.all(
    schoolsList.map((schoolId) => (
      fetchSchoolOrders({ schoolId, fromInt, toInt })
    ))
  )
    .catch((error) => console.log(error))
}

const fetchSchoolOrders = ({ schoolId, fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const { marketplace: { adminRegistryPage: { schools } } } = getState()

  return request.post(prefix.statSchool + `/${schoolId}`, {
    fromInt,
    toInt,
  })
    .then(({ data }) => data)
    .then(({ orders, total, totalPositions }) => {
      const school = schools.find(({ id }) => id === schoolId)

      reducers.marketplace.adminRegistryPage.updateOrdersData({ school, schoolOrders: orders, total, totalPositions })
    })
}

const fetchSchools = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schools + `?all=false`)
    .then(({ data }) => data)
    .then((schools) => (
      schools
        .sort((a, b) => {
          return a.title < b.title ? -1 : a.title > b.title ? 1 : 0
        })
    ))
    .then((schools) => {
      console.log({ schools })
      reducers.marketplace.adminRegistryPage.setSchools(schools)
      return schools
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchClasses = (schoolId) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schools + `/${schoolId}?all=false`)
    .then(({ data }) => data)
    .then((classes) => (
      classes
        .sort((a, b) => {
          if (a.grade === b.grade) {
            return a.letter < b.letter ? -1 : a.letter > b.letter ? 1 : 0
          }

          return a.grade < b.grade ? -1 : a.grade > b.grade ? 1 : 0
        })
    ))
    .then((classes) => {
      reducers.marketplace.adminRegistryPage.setClasses({ schoolId, classes })
    })
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchOrders,
  fetchSchools,
  fetchClasses,
}
